interface IGetStreetByAddressOptions {
  defaultValue?: string;
}

function getStreetByAddress(
  value?: string | null,
  options?: IGetStreetByAddressOptions,
): string {
  if (!value) {
    return options?.defaultValue || '';
  }

  const regexGetAllBeforeNumber = /^(.*?)[0-9]/g;

  const street = value.split(regexGetAllBeforeNumber)[1];

  return street;
}

export default getStreetByAddress;
